import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-right"
      expand={true}
      richColors
      closeButton
      duration={4000}
      toastOptions={{
        style: { zIndex: 9999 },
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-xl group-[.toaster]:rounded-lg group-[.toaster]:backdrop-blur-sm",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground group-[.toast]:hover:bg-primary/90 group-[.toast]:transition-colors",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          success: "group-[.toast]:bg-gradient-to-r group-[.toast]:from-green-500 group-[.toast]:to-green-600 group-[.toast]:text-white group-[.toast]:border-green-400 group-[.toast]:shadow-green-500/25",
          error: "group-[.toast]:bg-gradient-to-r group-[.toast]:from-red-500 group-[.toast]:to-red-600 group-[.toast]:text-white group-[.toast]:border-red-400 group-[.toast]:shadow-red-500/25",
          info: "group-[.toast]:bg-gradient-to-r group-[.toast]:from-gray-800 group-[.toast]:to-gray-900 group-[.toast]:text-white group-[.toast]:border-gray-700 group-[.toast]:shadow-blue-500/25",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
